export default "__VITE_ASSET__BbNUUFI2__"